import { RoamingInfo } from "@/services/model";
import { getTariffType, TariffTypes } from "@/utils/deviceUtils";

const getMaxVolume = (tariffType: TariffTypes) => {
  switch (tariffType) {
    case TariffTypes.flatMobileSwiss:
      return 2048;
    case TariffTypes.flatMobilePlus:
      return 12288;
    case TariffTypes.flatMobile:
    default:
      return 5120;
  }
};

export const useShouldDisplayRoamingHints = ({
  roamingInfo,
  serviceId,
}: {
  roamingInfo: RoamingInfo;
  serviceId?: number;
}) => {
  const tariffType = getTariffType(serviceId);

  // If the initial volume is less than x MB, we started the mobile abo somewhere in the middle of the month. In this case, we show a hint to the user explaining the odd volume.
  const shouldDisplayPartialHint =
    roamingInfo.initialVolume &&
    roamingInfo.initialVolume < getMaxVolume(tariffType);

  return {
    shouldDisplayPartialHint,
    shouldDisplayRenewalHint: !shouldDisplayPartialHint,
  };
};
